import { createRef, memo, useEffect } from "react";
import PropTypes from "prop-types";
import { resolutionPropType } from "app/utils/propTypes";
import VideoSwitchThumbnail from "app/pages/.shared/Video/VideoSwitchThumbnail";

import "./MediaArticle.scss";
import Separator from "app/pages/.shared/Separator";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg";
import Paragraphs from "app/pages/.shared/Paragraphs";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";

const MEDIA_IMG_DESKTOP_SIZES = {
	large: { width: 940, height: 460 },
	xlarge: { width: 940, height: 460 },
	medium: { width: 940, height: 460 },
	small: { width: 940, height: 460 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];

const MediaArticle = ({
	title,
	descriptions,
	videoType,
	videoUrl,
	photoThumbnail,
	photoUrl,
	resolution,
	author,
	onMediaClick,
	videoPreviewUrl,
	videoThumbnail,
}) => {
	let descriptionWrapperRef = createRef();

	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	useEffect(() => {
		// pour remonter le contenu de l'article lorsque l'on change d'article dont le contenu est trop lond, ce qui évite de rester en bas
		descriptionWrapperRef.current.scrollTop = 0;
	});

	const imageComponent = isMobile ? (
		<ProgressiveImg
			sizes={MEDIA_IMG_DESKTOP_SIZES}
			resolution={resolution}
			thumbnail={photoThumbnail}
			src={photoUrl}
			cloudinaryOptions={CLOUDINARY_OPTIONS}
		/>
	) : (
		<BackgroundProgressiveImg
			sizes={MEDIA_IMG_DESKTOP_SIZES}
			resolution={resolution}
			thumbnail={photoThumbnail}
			src={photoUrl}
			cloudinaryOptions={CLOUDINARY_OPTIONS}
			offset={0}
			backgroundPosition="center"
		/>
	);

	return (
		<div className="media-article">
			<div className="media-article__media" onClick={videoUrl ? () => {} : onMediaClick}>
				{videoUrl ? (
					<VideoSwitchThumbnail
						resolution={resolution}
						sizes={MEDIA_IMG_DESKTOP_SIZES}
						videoType={videoType}
						videoUrl={videoUrl}
						videoPreviewUrl={photoUrl ? photoUrl : videoPreviewUrl}
						videoThumbnail={photoThumbnail ? photoThumbnail : videoThumbnail}
					/>
				) : (
					imageComponent
				)}
			</div>
			<div className="media-article__article">
				<h3 className="media-article__title">{title}</h3>
				<div className="media-article__scroller" ref={descriptionWrapperRef}>
					<Separator design="middle" />
					<div className="media-article__description">
						<Paragraphs paragraphs={descriptions} enableHTMLFormatting />
					</div>
				</div>
				<div className="media-article__footer">
					{author && <div className="media-article__copyright">© {author}</div>}
				</div>
			</div>
		</div>
	);
};
MediaArticle.defaultProps = {
	onMediaClick: () => {},
	descriptions: [],
};
MediaArticle.propTypes = {
	videoPreviewUrl: PropTypes.string,
	onMediaClick: PropTypes.func,
	title: PropTypes.string,
	resolution: resolutionPropType,
	descriptions: PropTypes.arrayOf(PropTypes.string),
	videoType: PropTypes.string,
	videoUrl: PropTypes.string,
	videoThumbnail: PropTypes.string,
	photoThumbnail: PropTypes.string,
	photoUrl: PropTypes.string,
	author: PropTypes.string,
};

export default memo(MediaArticle);
